import React, { ReactElement } from 'react';
import { Box, Button, Divider } from '@material-ui/core';

import './dialog-window-footer.styles.scss';
import { useTranslation } from 'react-i18next';

export interface IDialogWindowFooterProps {
	confirmText?: string;
	cancelText?: string;
	disableConfirm?: boolean;
	disableCancel?: boolean;
	onConfirm: () => void;
	onCancel: () => void;
}

export function DialogWindowFooter(
	props: IDialogWindowFooterProps
): ReactElement {
	const {
		confirmText,
		cancelText,
		disableConfirm,
		disableCancel,
		onConfirm,
		onCancel
	} = props;

	const { t } = useTranslation('general');

	return (
		<Box className="dialog-window-footer">
			<Divider />
			<Box className="dialog-window-footer-controls">
				<Button
					color="primary"
					onClick={onCancel}
					disabled={disableCancel}
				>
					{cancelText ? cancelText : t('dialog.cancel')}
				</Button>
				<Button
					variant="contained"
					color="primary"
					onClick={onConfirm}
					disabled={disableConfirm}
				>
					{confirmText ? confirmText : t('dialog.confirm')}
				</Button>
			</Box>
		</Box>
	);
}
